// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__LkNtw","container__coin":"styles_container__coin__G_5Cr","skeleton-animation":"styles_skeleton-animation__B7jgm"};